function formatTime(secs: number): string {
	let timeStr = '00:00'
	if (secs) {
		const mins = Math.floor(secs / 60)
		const secsLeft = secs - mins * 60
		timeStr = `${String(mins).padStart(2, '0')}:${String(secsLeft).padStart(2, '0')}`
	}
	return timeStr
}

export default formatTime
